import angular from 'angular'
import sweetalert from './sweetalertFactory'

export default angular
    .module('app.sweetalert', [])
    .factory('sweetalert', sweetalert)
    .name



// WEBPACK FOOTER //
// ./src/components/sweetalert/index.js